import React from "react";
import { useTheme } from "src/context/theme.context";

const Cell = ({ className }: { className?: string }) => (
  <div className={`h-3 rounded bg-gray-200 dark:bg-gray-600 animate-pulse ${className || ""}`} />
);

/**
 * Takes `showSummary` rather than assuming five columns.
 *
 * It was five fixed cells, which is one too many on Saved searches — that tab
 * hides the summary column — and became one too few when Actions was added. A
 * skeleton whose column count disagrees with the header shifts the whole table
 * on the frame the data lands.
 */
export const RecruiterTableSkeleton: React.FC<{ rows?: number; showSummary: boolean }> = ({
  rows = 8,
  showSummary,
}) => {
  const { isDarkMode } = useTheme();
  const rowBg = isDarkMode ? "bg-gray-800/60" : "odd:bg-white even:bg-gray-50";
  const borderCls = isDarkMode ? "border-gray-700" : "border-gray-200";

  return (
    <>
      {Array.from({ length: rows }).map((_, i) => (
        <tr key={i} className={`text-left ${rowBg}`}>
          <td className={`px-4 py-3 border-t ${borderCls}`}><Cell className="w-20" /></td>
          <td className={`px-4 py-3 border-t ${borderCls}`}><Cell className="w-32" /></td>
          <td className={`px-4 py-3 border-t ${borderCls}`}><Cell className="w-40" /></td>
          {showSummary && (
            <td className={`px-4 py-3 border-t ${borderCls}`}><Cell className="max-w-xs" /></td>
          )}
          <td className={`px-4 py-3 border-t ${borderCls}`}><Cell className="w-20" /></td>
          <td className={`px-4 py-3 border-t ${borderCls}`}><Cell className="h-7 w-20" /></td>
        </tr>
      ))}
    </>
  );
};
